import type { ReactNode } from "react";
import { AlertTriangle, FileSearch, ShieldAlert } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

type Tone = "empty" | "no-access" | "error";

interface EmptyStateProps {
  tone?: Tone;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ tone = "empty", title, description, action }: EmptyStateProps) {
  const Icon = tone === "no-access" ? ShieldAlert : tone === "error" ? AlertTriangle : FileSearch;
  return (
    <Card>
      <CardContent className="py-12 flex flex-col items-center text-center gap-3">
        <Icon className="size-10 text-muted-foreground" />
        <h3 className="text-lg font-semibold">{title}</h3>
        {description ? (
          <p className="text-sm text-muted-foreground max-w-md">{description}</p>
        ) : null}
        {action}
      </CardContent>
    </Card>
  );
}
